import { IconType } from './model/enum.model';

import { iconLinks1, iconLinks2, iconLinks3, iconLinksRisk, iconLinksVWC } from './fleet-tracker-icon-links';

export class FleetTrackerIcons {

    public static cluster = 'assets/images/fleet-tracker/cluster/cluster.png';

    public iconMap: Map<IconType, string> = new Map();

    constructor() {

        iconLinks1.forEach((v, k) => {
            this.iconMap.set(k, v);
        });
        iconLinks2.forEach((v, k) => {
            this.iconMap.set(k, v);
        });
        iconLinks3.forEach((v, k) => {
            this.iconMap.set(k, v);
        });
        iconLinksRisk.forEach((v, k) => {
            this.iconMap.set(k, v);
        });
        iconLinksVWC.forEach((v, k) => {
            this.iconMap.set(k, v);
        });
    }
}
